import { X } from 'lucide-react';

export default function AssessmentResultView({ result, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-in fade-in duration-200">
      <div className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-gradient-to-r from-[#4F7CFF] to-[#6B8FFF] border-b border-blue-400/30 px-6 py-5 flex items-center justify-between rounded-t-2xl">
          <h2 className="text-2xl font-bold text-white">Detail Hasil Asesmen</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-white/20 rounded-xl transition-all"
          >
            <X className="w-5 h-5 text-white" />
          </button>
        </div>

        <div className="p-6 space-y-6">
          <div className="grid grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Nama Lengkap
              </label>
              <p className="text-gray-900 font-semibold">{result.test_taker_name}</p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Gender
              </label>
              <p className="text-gray-900">{result.gender || '-'}</p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Usia
              </label>
              <p className="text-gray-900">
                {result.age ? `${result.age} tahun` : '-'}
              </p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Voucher
              </label>
              <p className="text-gray-900 font-mono text-sm">{result.voucher}</p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Distributor
              </label>
              <p className="text-gray-900">{result.distributor}</p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Tanggal Asesmen
              </label>
              <p className="text-gray-900">
                {new Date(result.created_at).toLocaleDateString('id-ID', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </p>
            </div>
          </div>

          <div className="border-t border-gray-200 pt-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Hasil Analisis</h3>

            <div className="space-y-4">
              <div className="bg-gradient-to-br from-blue-50 to-blue-100/50 rounded-xl p-5 border border-blue-200/50 shadow-sm">
                <label className="block text-sm font-bold text-blue-900 mb-2 flex items-center gap-2">
                  <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                  Kekuatan (Strengths)
                </label>
                <p className="text-gray-800 whitespace-pre-wrap leading-relaxed">
                  {result.strengths || '-'}
                </p>
              </div>

              <div className="bg-gradient-to-br from-green-50 to-green-100/50 rounded-xl p-5 border border-green-200/50 shadow-sm">
                <label className="block text-sm font-bold text-green-900 mb-2 flex items-center gap-2">
                  <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                  Gaya Belajar (Learning Styles)
                </label>
                <p className="text-gray-800 whitespace-pre-wrap leading-relaxed">
                  {result.learning_styles || '-'}
                </p>
              </div>

              <div className="bg-gradient-to-br from-purple-50 to-purple-100/50 rounded-xl p-5 border border-purple-200/50 shadow-sm">
                <label className="block text-sm font-bold text-purple-900 mb-2 flex items-center gap-2">
                  <span className="w-2 h-2 bg-purple-500 rounded-full"></span>
                  Rekomendasi Ekstrakurikuler
                </label>
                <p className="text-gray-800 whitespace-pre-wrap leading-relaxed">
                  {result.extracurricular_recommendations || '-'}
                </p>
              </div>

              <div className="bg-gradient-to-br from-amber-50 to-amber-100/50 rounded-xl p-5 border border-amber-200/50 shadow-sm">
                <label className="block text-sm font-bold text-amber-900 mb-2 flex items-center gap-2">
                  <span className="w-2 h-2 bg-amber-500 rounded-full"></span>
                  Minat &amp; Bakat
                </label>
                <p className="text-gray-800 whitespace-pre-wrap leading-relaxed">
                  {result.minat_bakat || '-'}
                </p>
              </div>
            </div>
          </div>

          {result.scores && (
            <div className="border-t border-gray-200 pt-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Skor Detail</h3>
              <div className="bg-gradient-to-br from-gray-50 to-gray-100/50 rounded-xl p-5 border border-gray-200 shadow-sm">
                <pre className="text-sm text-gray-700 overflow-x-auto">
                  {JSON.stringify(result.scores, null, 2)}
                </pre>
              </div>
            </div>
          )}
        </div>

        <div className="sticky bottom-0 bg-gradient-to-r from-gray-50 to-gray-100/50 border-t border-gray-200 px-6 py-4 flex justify-end rounded-b-2xl">
          <button
            onClick={onClose}
            className="px-6 py-2.5 bg-gradient-to-r from-gray-600 to-gray-700 text-white rounded-xl hover:from-gray-700 hover:to-gray-800 transition-all shadow-lg shadow-gray-500/30 font-medium"
          >
            Tutup
          </button>
        </div>
      </div>
    </div>
  );
}
